import { Zap, MessageSquareText, UserRound, Bot } from "lucide-react";

// Mockup dimostrativo del costruttore automazioni: dati sintetici.
const Node = ({ icon: Icon, label, title, text, color }) => (
  <div className="rounded-xl border !border-slate-700/80 !bg-[#111827] p-3 shadow-lg shadow-black/30">
    <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.12em]" style={{ color }}><Icon className="h-3 w-3" /> {label}</p>
    <p className="mt-1 text-sm font-semibold text-white">{title}</p>
    {text && <p className="mt-1 text-xs text-slate-400">{text}</p>}
  </div>
);

const Arrow = () => <div className="mx-auto h-5 w-px bg-slate-700" aria-hidden="true" />;

export const AutomationPreview = () => (
  <div className="rounded-2xl border !border-slate-800 !bg-[#0F172A] p-4 sm:p-5 bg-[radial-gradient(rgba(255,255,255,.04)_1px,transparent_1px)] [background-size:16px_16px]" data-testid="landing-automation-preview">
    <Node icon={Zap} label="Trigger" title="Parola chiave «OFFERTE»" text="Oppure: primo messaggio, orario non lavorativo, clic su un link" color="#F59E0B" />
    <Arrow />
    <Node icon={MessageSquareText} label="Messaggio" title="Benvenuto {{nome}}! Cosa ti interessa?" text="1 · Volantino della settimana   2 · Orari e punti vendita   3 · Parla con un operatore" color="#10B981" />
    <Arrow />
    <div className="grid grid-cols-2 gap-3">
      <Node icon={Bot} label="Assistente IA" title="Risponde da base di conoscenza" color="#60A5FA" />
      <Node icon={UserRound} label="Operatore" title="Passaggio con notifica" color="#A78BFA" />
    </div>
    <p className="mt-4 text-[11px] text-slate-500">Oltre le 24 ore il follow-up usa un template di riserva approvato da Meta.</p>
  </div>
);
